require('core-js/stable');
require('./iron/common/polyfills');
